import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';
import { SessionService } from '@unity/services/session.service';
import { BannerContextSharedComponent } from '@unity/shared/presentation/banner-context-shared/banner-context-shared.component';

@Component({
  selector: 'unity-index',
  standalone: true,
  imports: [KENDO_GRIDLAYOUT, KENDO_BUTTON, RouterOutlet, BannerContextSharedComponent],
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss',
})
export class IndexComponent {
  private readonly sessionService = inject(SessionService);

  protected $environmentName = this.sessionService.$environmentName;

  protected mainContentWidth = 'min(100%, 1400px)';
}
